<script setup>
import PlatformLayout from './layouts/platform-layout.vue';
</script>

<template>
    <div class="evo-flex evo-flex-col evo-w-full evo-h-full evo-min-h-screen">
        <platform-layout>
            <router-view></router-view>
        </platform-layout>
    </div>
</template>
